import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import thunk, { ThunkMiddleware } from "redux-thunk";

import { MapReducer } from "./MapReducer";

const mapRootReducer = combineReducers({
	Map: MapReducer,
});

export type MapRootState = ReturnType<typeof mapRootReducer>;

export interface DispatchAction extends Action {
	payload: any;
}

const middleware = thunk as ThunkMiddleware<MapRootState, DispatchAction>;

export const mapStore = configureStore({
	reducer: mapRootReducer,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware().concat(middleware),
});
